<template>
  <ol class="breadcrumbs">
    <template v-for="(item, index) in items">
      <li class="breadcrumbs__item" :key="index">
        <router-link :to="{ name: item.route }">{{ item.title }}</router-link>
        <font-awesome-icon :style="{ color: 'grey' }" icon="caret-right" />
      </li>
    </template>
    <li class="breadcrumbs__item">
      <span>{{ active }}</span>
    </li>
  </ol>
</template>

<script>
export default {
  name: 'breadcrumbs',
  props: {
    active: {
      type: String,
      required: true,
    },
    items: {
      type: [Array],
      required: true,
    },
  },
};
</script>

<style lang="scss">
.breadcrumbs {
  list-style-type: none;
  display: flex;
  padding: 0;
  margin: 0;
  height: 40px;
  align-items: center;
  font-size: 0.9rem;
  margin-bottom: 8px;

  &__item {
    display: flex;
    align-items: center;
    margin-right: 8px;

    a {
      margin-right: 8px;
      color: color('secondary');
    }
  }
}
</style>
